import { RootState } from "@/store/store";
import { getAiKubernetesRecommendationsEndpointSelector } from "@/store/ai-kubernetes-recommendations/selectors/getAiKubernetesRecommendationsEndpointSelector";

export const getAiKubernetesRecommendationsLoadingSelector = (
  state: RootState,
) => {
  return getAiKubernetesRecommendationsEndpointSelector(state)?.isLoading;
};
